import type { VFC } from 'react';
import styled from 'styled-components';
import { Button, type ButtonProps } from 'antd';
import { getActionsButtonStyleByType } from 'components/enmon/buttons/utils/getButtonStyleByType';
import { getGeneralButtonStyle } from 'components/enmon/buttons/utils/getGeneralButtonStyle';

export const StyledButton: typeof Button = styled(Button)<VFC<ButtonProps>>`
  &.ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    // STYLES FOR ALL BUTTONS
    ${getGeneralButtonStyle}

    // STYLES FOR BUTTONS WITH DIFFERENT TYPES
    ${({ type }) => getActionsButtonStyleByType(type)}
  }
`;
